
import { useEffect, useState } from "react";
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

const GenericTagChips = (props) => {
    const [genericTags, setGenericTags] = useState([]);

    useEffect(() => {
        let formattedTags = []
        if (props?.bank) {
            formattedTags.push({
                title: "Bank",
                body: props.bank
            })
        }
        if (props?.beneficiary) {
            formattedTags.push({
                title: "Beneficiary",
                body: props?.beneficiary
            })
        }
        if (props?.purpose && props?.purpose?.name) {
            formattedTags.push({
                title: "Purpose",
                body: props.purpose.name
            })
        }

        const formattedGenericTags = (props.genericTags || []).map((entry) => {
            let title = ''
            let currPart = entry
            let parts = []
            while (currPart) {
                if (currPart.name) {
                    parts.push(currPart.name)
                }
                if (typeof currPart.parent === "number" && !title) {
                    title = currPart?.parent_name;
                } else if (currPart.parent == null && !title) {
                    title = currPart.group?.name || currPart.group_name;
                }
                currPart = currPart.parent
            }
            return {
                title: title,
                body: parts.reverse().join(" / ")
            }
        })

        let formattedGenericMap = []
        if (props.genericMap) {
            formattedGenericMap = Object.keys(props.genericMap || {}).map((key) => {
                let body = props.genericMap[key]
                if (Array.isArray(body)) {
                    body = body.reverse().join(" / ")
                }
                return {
                    title: key,
                    body: body
                }
            })
        }


        setGenericTags([...formattedTags, ...formattedGenericTags, ...formattedGenericMap])

    }, [props.genericTags, props.purpose, props.genericMap])

    return (
        <>
            {genericTags.length ?
                <Stack direction="row" flexWrap="wrap"
                >
                    {genericTags.map((item) => {
                        return <Chip
                            label={<Stack direction="column" spacing={0}>
                                <Typography variant="overline" sx={{ mb: -1 }}>{item.title}</Typography>
                                <Typography variant="h5" color="primary" fontSize={12}>{item.body}</Typography>
                            </Stack>}
                            sx={{ mt: 1, mr: 1 }}
                        />
                    })}

                </Stack> : undefined}
        </>
    );
};

export default GenericTagChips;
